import React, { useState, useEffect } from "react";
import '../styles/font-awesome.min.css';

export default function Footer() {

    const [openIndexes, setOpenIndexes] = useState([]);

    // Detecta mobile (opcional, como no jQuery)
    const [isMobile, setIsMobile] = useState(false);
        useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 760);
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
        }, []);

    const toggleMenu = (index, e) => {
        if (e.target.tagName.toLowerCase() === 'a') {
            return;
        }

        e.preventDefault();
        if (!isMobile) return; // só abre em mobile
        setOpenIndexes((prev) =>
            prev.includes(index)
            ? prev.filter((i) => i !== index)
            : [...prev, index]
        );
    };

  return (
    <div>
        <div className="whatsAppGlobal">
            <a href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%c3%a1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%c3%a7%c3%b5es%20sobre%20aulas%20de%20Pilates" className="wpp-float" target="_blank">
                <i className="fa fa-whatsapp wpp-my-float"></i>
            </a>
        </div>

        <footer>
            <div className="pilates-footer-logo">
                <div className="pilates-footer-icon"></div>
            </div>

            <div className="pilates-footer-link-container">

                <div className={`pilates-footer-item--bold ${openIndexes.includes(0) ? "is--active" : ""}`} onClick={(e) => toggleMenu(0, e)}>

                    <span className="pilates-footer-link pilates-footer-link--bold">Saiba mais</span>

                    <ul className="pilates-footer-list pilates-footer-list_01">
                        {/* <li className="pilates-footer-item">
                            <a href="quem-somos.html" className="pilates-footer-link">Quem Somos</a>
                        </li> */}

                        <li className="pilates-footer-item">
                            <a href="/o-pilates" className="pilates-footer-link">O Pilates</a>
                        </li>

                        <li className="pilates-footer-item">
                            <a href="/beneficios" className="pilates-footer-link">Benefícios do Pilates</a>
                        </li>
                    </ul>
                </div>

                <div className={`pilates-footer-item--bold ${openIndexes.includes(1) ? "is--active" : ""}`} onClick={(e) => toggleMenu(1, e)}>
                    <span className="pilates-footer-link pilates-footer-link--bold">Equipamentos</span>

                    <ul className="pilates-footer-list pilates-footer-list_01">

                        <li className="pilates-footer-item">
                            <a href="/equipamentos" className="pilates-footer-link">Studio de Pilates</a>
                        </li>
                        <li className="pilates-footer-item">
                            <a href="/equipamentos/cadillac" className="pilates-footer-link">&nbsp;&nbsp;- Cadillac</a>
                        </li>
                        <li className="pilates-footer-item">
                            <a href="/equipamentos/reformer" className="pilates-footer-link">&nbsp;&nbsp;- Reformer</a>
                        </li>
                        <li className="pilates-footer-item">
                            <a href="/equipamentos/barrel" className="pilates-footer-link">&nbsp;&nbsp;- Barrel</a>
                        </li>
                        <li className="pilates-footer-item">
                            <a href="/equipamentos/chair" className="pilates-footer-link">&nbsp;&nbsp;- Chair</a>
                        </li>
                    </ul>
                </div>


                <div className={`pilates-footer-item--bold ${openIndexes.includes(2) ? "is--active" : ""}`} onClick={(e) => toggleMenu(2, e)}>
                    <span className=" pilates-footer-link--bold">Fale conosco</span>
                    <ul className="pilates-footer-list pilates-footer-list_02">

                        <li className="pilates-footer-item">
                            <a href="/contato" className="pilates-footer-link">Contato</a>
                        </li>

                        <li className="pilates-footer-item">
                            <a href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%c3%a1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%c3%a7%c3%b5es%20sobre%20aulas%20de%20Pilates" target="_blank" className="pilates-footer-link">WhatsApp</a>
                        </li>

                    </ul>
                </div>

                <div className={`pilates-footer-item--bold ${openIndexes.includes(3) ? "is--active" : ""}`} onClick={(e) => toggleMenu(3, e)}>
                    <span className="pilates-footer-link--bold">Redes sociais</span>
                    <ul className="pilates-footer-list pilates-footer-list_04">
                        <li className="pilates-footer-item">
                            <a href="https://www.instagram.com/osteovitta/" className="pilates-footer-link Instagram" target="_blank">Instagram</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="pilates-footer-rights">
                <span className="pilates-footer-rights-text">
                    © 2026 Todos os direitos reservados<br />
                    OsteoVitta Fisioterapia & Pilates
                </span>

            </div>

            <div className="pilates-lgpd-fixed">
                <div className="pilates-lgpd-fixe-block">
                    <div className="pilates-lgpd-fixed--block-title">
                        Usamos cookies para dar a você uma melhor experiência em nosso website. Para continuar, clique no botão.
                        Conheça nossa <a href="politica-de-privacidade.html">política de privacidade</a>
                    </div>
                    <button className="pilates-lgpd-fixe-block-btn">entendi</button>
                </div>
            </div>
        </footer>
    </div>
  );
}